import { AccrualType, AccrualTypeEnum } from '../types/leave-policy'

interface IGetToAccrueDaysAndHoursReturn {
  toAccrueDays: number
  toAccrueHours: number
}

const getToAccrueDaysAndHours = (
  hourlyLeaveAccounting: boolean,
  accrualType: AccrualType,
  quota: number,
  averageNumberOfWorkingHoursPerDay: number
): IGetToAccrueDaysAndHoursReturn => {
  if (accrualType === AccrualTypeEnum.monthly) {
    const earnInUnit = quota / 12
    return {
      toAccrueDays: hourlyLeaveAccounting ? earnInUnit / averageNumberOfWorkingHoursPerDay : earnInUnit,
      toAccrueHours: hourlyLeaveAccounting ? earnInUnit : earnInUnit * averageNumberOfWorkingHoursPerDay,
    }
  } else if (accrualType === AccrualTypeEnum.semiMonthly) {
    const earnInUnit = quota / 24
    return {
      toAccrueDays: hourlyLeaveAccounting ? earnInUnit / averageNumberOfWorkingHoursPerDay : earnInUnit,
      toAccrueHours: hourlyLeaveAccounting ? earnInUnit : earnInUnit * averageNumberOfWorkingHoursPerDay,
    }
  } else if (accrualType === AccrualTypeEnum.biWeekly) {
    const earnInUnit = quota / 26
    return {
      toAccrueDays: hourlyLeaveAccounting ? earnInUnit / averageNumberOfWorkingHoursPerDay : earnInUnit,
      toAccrueHours: hourlyLeaveAccounting ? earnInUnit : earnInUnit * averageNumberOfWorkingHoursPerDay,
    }
  } else if (accrualType === AccrualTypeEnum.weekly) {
    const earnInUnit = quota / 52
    return {
      toAccrueDays: hourlyLeaveAccounting ? earnInUnit / averageNumberOfWorkingHoursPerDay : earnInUnit,
      toAccrueHours: hourlyLeaveAccounting ? earnInUnit : earnInUnit * averageNumberOfWorkingHoursPerDay,
    }
  }

  return {
    toAccrueDays: NaN,
    toAccrueHours: NaN,
  }
}

export default getToAccrueDaysAndHours